var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "960px", "margin-bottom": "20px" },
          attrs: { placeholder: "请选择版块" },
          model: {
            value: _vm.categoryId,
            callback: function($$v) {
              _vm.categoryId = $$v
            },
            expression: "categoryId"
          }
        },
        _vm._l(_vm.sectionList, function(item, i) {
          return _c("el-option", {
            key: i,
            attrs: { label: _vm.replace(item.name), value: item.id }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("el-input", {
        ref: "position",
        staticStyle: { width: "960px", "margin-bottom": "20px" },
        attrs: {
          placeholder: "请输入您的问题标题",
          clearable: "",
          disabled: _vm.num == 1
        },
        model: {
          value: _vm.input,
          callback: function($$v) {
            _vm.input = $$v
          },
          expression: "input"
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticStyle: { width: "960px" },
        attrs: { id: "globalEditorBox" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "file" },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                drag: "",
                action: _vm.fileUrl,
                multiple: "",
                "on-success": _vm.upSuccess,
                "on-remove": _vm.handleRemove,
                "before-upload": _vm.beforeAvatarUpload
              }
            },
            [_c("p", [_vm._v("上传附件(仅支持PDF格式文件)")])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-376cd330", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-376cd330","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pc/components/release/globalAsk.vue
// module id = null
// module chunks = 